import escapeHtml from 'escape-html';
const LOREM_IPSUM = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
const appendLongText = (text) => {
    return `${text} - ${LOREM_IPSUM}`;
};
const appendEncodableText = (text) => {
    return `${text} - ©<>&'`;
};
const isHtmlTranslation = (key) => !!key && key.toLowerCase().endsWith('html');
const wrapInDebugText = (text) => {
    if (text == null) {
        return 'X (MISSING TEMPLATE) X';
    }
    return `✓ ${text} ✓`;
};
const applyDebugOptions = (text, options) => {
    let debugText = text;
    if (options.encodedText) {
        debugText = appendEncodableText(debugText);
    }
    if (options.longText) {
        debugText = appendLongText(debugText);
    }
    if (options.wrap) {
        debugText = wrapInDebugText(debugText);
    }
    return debugText;
};
export const formatLocalizedText = (key, originalText, options) => {
    options = options || {};
    const shouldEscapeHtml = options.expectHtml && !isHtmlTranslation(key) && originalText;
    let text = applyDebugOptions(originalText, options);
    text = shouldEscapeHtml ? escapeHtml(text) : text;
    return text ?? '';
};
export const getTranslationOptions = (locale, expectHtml) => ({
    expectHtml,
    encodedText: locale?.toLowerCase() === 'en-qa-encoded',
    longText: locale?.toLowerCase() === 'en-qa-long',
    wrap: locale?.toLowerCase() === 'en-qa'
});
